import React from 'react';
import copy from '../../assets/images/copy-white.svg';
import coinMarketCap from '../../assets/images/coinmarketcap.svg';
import up from '../../assets/images/trending-up.svg'
import down from '../../assets/images/trending-down.svg'
import {
    formatNumberWithSubscriptZeros
} from "@haqq/format-number-with-subscript-zeros";

const SignalsNewComponent = ({item, showModal, copyAddress, index, isSpotters}) => {
    return (
        <div key={index.toString()} className={`signal-signalContainer ${item?.alarm_type === 'buy' ? 'signal-signalLong' : 'signal-signalShort'} ${isSpotters ? 'signal-spotter' : ''} ${showModal ? 'grayFilter' : ''} ${item?.alarm_status}`}>
            <div className="start column w100">
                <div className="w100 start flex1 minW30 mr10 lineNumber1">
                    <img alt={item?.token_name} src={item?.token_logo} className="signal-alarmTokenImage" />
                    <div className="start column between ml10 h100 lineNumber1">
                        <div className="start">
                            <p className={`signal-signalTypeText ${item?.alarm_type === 'buy' ? 'signal-signalTypeTextLong' : 'signal-signalTypeTextShort'}`}>{item?.alarm_type === 'buy' ? 'LONG ALARM' : 'SHORT ALARM'}</p>
                            <img alt="signal-type" src={item?.alarm_type === 'buy' ? up : down} className="signal-signalTypeIcon" />
                        </div>
                        <div className="signal-tokenDataText">
                            <p className="font-bold fs14 text-white lineNumber1 minW30">{`${item?.token_name} (${item?.token_symbol})`}</p>
                            <p className="fs14 text-white lineNumber1 minW30">{`Chain: ${item?.chain}`}</p>
                        </div>
                    </div>
                    <div className="activeInMd end column justifyStart">
                        <p className="fs16 font-bold text-white">{isSpotters ? 'Power' : 'Price'}</p>
                        <p className="fs30 font-normal text-right text-white lineNumber1 maxW200">{isSpotters ? item?.power : `$${formatNumberWithSubscriptZeros(item?.usd_price ? item?.usd_price?.toString() : '-')}`}</p>
                        <p className="fs12 text-white nowrap">{`${item?.time_at?.replace('T', '/').split('.')[0]} GMT`}</p>
                    </div>
                </div>
                <div className="activeInSm w100 center between mb5">
                    <p className="fs16 font-bold text-white">{isSpotters ? 'Power' : 'Price'}</p>
                    <p className="fs30 font-normal text-right text-white lineNumber1 maxW200">{isSpotters ? item?.power : `$${formatNumberWithSubscriptZeros(item?.usd_price ? item?.usd_price?.toString() : '-')}`}</p>
                </div>
                <p className="activeInSm w100 text-right fs12 text-white nowrap mb5 end lineNumber1 minW30">{`${item?.time_at?.replace('T', '/').split('.')[0]} GMT`}</p>
                <div className="wrap w100 start">
                    <p className="fs14 mt5 text-white font-bold mr10">{`Token Address\xa0\xa0\xa0`}</p>
                    <p className="fs14 mt5 minW30 text-white lineNumber1 wUnset">{item?.token_addr}</p>
                </div>
                <div className="w100 center between wrap mt20">
                    <button type="button" className={`signals-button center text-white fs14 pointer ${isSpotters ? 'spotterCopyBtn' : ''}`} onClick={() => copyAddress(item?.token_addr)}>
                        <img alt={item?.token_name} src={copy} className="affiliate-copyImg" />
                        <span className="ml5 lineNumber1 wUnset">Copy Contract Address</span>
                    </button>
                    <a href={item?.cmc_link} target="_blank" rel="noreferrer noopener" className={`signals-button coinMarketCap-bg center text-white fs14 minW30 pointer ${isSpotters ? 'spotterCmcBtn' : ''}`}>
                        <img alt={item?.token_name} src={coinMarketCap} className="affiliate-copyImg" />
                        <span className="ml5 lineNumber1 wUnset">View On CoinMarketCap</span>
                    </a>
                </div>
            </div>
            {item?.alarm_status && <div className="signal-alarmStatus"
                                           style={{backgroundColor: `${item?.alarm_status?.color}99` ?? 'transparent'}}>
                <p style={{color: item?.alarm_status?.txt_color ?? 'transparent'}} className="fs16 text-center">{item?.alarm_status?.txt}</p>
            </div>}
        </div>
    );
}

export default SignalsNewComponent;
